// extracted by mini-css-extract-plugin
module.exports = {"TextWithColor":"styles_TextWithColor__1ANj_","TextWithColor_Color":"styles_TextWithColor_Color__1JJzw","TextWithColor_Name":"styles_TextWithColor_Name__35x-H"};